"use strict";

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var get;

exports.default = get = function (object, path) {
  var index, length;
  index = 0;
  length = path.length;
  while (object != null && index < length) {
    object = object[path[index++]];
  }
  if (index === length) {
    return object;
  } else {
    return void 0;
  }
};